import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "./App.css";
import { AnalyticsProvider } from "./components/providers/AnalyticsProvider";
import ProtectedRoute from "./components/ProtectedRoute";
import { GlobalFeedbackPopup } from "./components/GlobalFeedbackPopup";

// Import pages
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import AuthCallback from "./pages/AuthCallback";
import Journal from "./pages/Journal";
import TherapistDashboard from "./pages/TherapistDashboard";
import ProfileEditor from "./pages/ProfileEditor";
import Therapists from "./pages/Therapists";
import Admin from "./pages/Admin";
import Test from "./pages/Test";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TherapistApproval from "./pages/TherapistApproval";
import AllFeedback from "./pages/AllFeedback";
import AllJournalEntries from "./pages/AllJournalEntries";
import TherapistClientJournalEntries from "./pages/TherapistClientJournalEntries";
import TherapistJournalEntryView from "./pages/TherapistJournalEntryView";
import ResetPassword from "./pages/ResetPassword";
import TherapistVerification from "./pages/TherapistVerification";
import JournalEntryView from "./pages/JournalEntryView";
import Landing from "./pages/Landing";

function App() {
  return (
    <Router>
      <AnalyticsProvider>
        <Routes>
          {/* Landing page */}
          <Route path="/" element={<Landing />} />
          <Route path="/landing" element={<Landing />} />
          
          {/* Auth routes */}
          <Route path="/auth" element={<Auth />} />
          <Route path="/client-login" element={<Auth role="client" />} />
          <Route path="/therapist-login" element={<Auth role="therapist" />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/auth/reset-password" element={<ResetPassword />} />
          
          {/* Public routes */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/therapist-approval" element={<TherapistApproval />} />
          <Route path="/test" element={<Test />} />
          <Route path="/therapists" element={<Therapists />} />
          <Route path="/admin" element={<Admin />} />
          
          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={["client", "therapist"]}>
                <Index />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/journal"
            element={
              <ProtectedRoute allowedRoles={["client"]}>
                <Journal />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/journal/all"
            element={
              <ProtectedRoute allowedRoles={["client"]}>
                <AllJournalEntries />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/journal/entry/:entryId"
            element={
              <ProtectedRoute allowedRoles={["client"]}>
                <JournalEntryView />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/therapist"
            element={
              <ProtectedRoute allowedRoles={["therapist"]}>
                <TherapistDashboard />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/profile"
            element={
              <ProtectedRoute allowedRoles={["client", "therapist"]}>
                <ProfileEditor />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/therapist/verify"
            element={
              <ProtectedRoute allowedRoles={["therapist"]}>
                <TherapistVerification />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/feedback"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AllFeedback />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/therapist/client/:clientId/journal-entries"
            element={
              <ProtectedRoute allowedRoles={["therapist"]}>
                <TherapistClientJournalEntries />
              </ProtectedRoute>
            }
          />

          <Route
            path="/therapist/client/:clientId/journal-entry/:entryId"
            element={
              <ProtectedRoute allowedRoles={["therapist"]}>
                <TherapistJournalEntryView />
              </ProtectedRoute>
            }
          />
          
          {/* Catch all route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster />
      </AnalyticsProvider>
    </Router>
  );
}

export default App;
